var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "Entry ID" },
                model: {
                  value: _vm.searchData.entry_id,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "entry_id", $$v)
                  },
                  expression: "searchData.entry_id "
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "类型" },
                  model: {
                    value: _vm.searchData.kind,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "kind", $$v)
                    },
                    expression: "searchData.kind"
                  }
                },
                _vm._l(_vm.kindList, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { staticStyle: { "text-align": "right" }, attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          attrs: { id: "tableRef", data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", {
            attrs: { label: "Review", width: "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "cell-break" }, [
                      _c("span", { staticClass: "text-bold" }, [
                        _vm._v(_vm._s(scope.row.review_id))
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "text-muted",
                          staticStyle: { "margin-top": "4px" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$times.formDate(scope.row.created_at))
                          )
                        ]
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "actor_name", label: "操作者", width: "150" }
          }),
          _c("el-table-column", {
            attrs: { label: "Entry" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "cell-break" }, [
                      _c("span", { staticClass: "text-bold" }, [
                        _vm._v(_vm._s(scope.row.entry_id))
                      ]),
                      _c(
                        "div",
                        { staticStyle: { "margin-top": "4px" } },
                        [
                          _c(
                            "el-tag",
                            {
                              staticStyle: { "margin-right": "5px" },
                              attrs: { size: "mini", type: "success" }
                            },
                            [_vm._v(_vm._s(scope.row.kind))]
                          ),
                          _c("span", { staticClass: "text-secondary" }, [
                            _vm._v("/ " + _vm._s(scope.row.title))
                          ])
                        ],
                        1
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "影响", width: "160" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "metrics-container" }, [
                      _c("div", [
                        _vm._v("group: "),
                        _c("span", { staticClass: "text-bold" }, [
                          _vm._v(_vm._s(scope.row._groupLen))
                        ])
                      ]),
                      _c("div", [
                        _vm._v("checks: "),
                        _c("span", { staticClass: "text-bold" }, [
                          _vm._v(_vm._s(scope.row._checksLen))
                        ])
                      ]),
                      _c("div", [
                        _vm._v("metrics: "),
                        _c("span", { staticClass: "text-bold" }, [
                          _vm._v(_vm._s(scope.row._metricsSum))
                        ])
                      ]),
                      _c("div", [
                        _vm._v("context: "),
                        _c("span", { staticClass: "text-bold" }, [
                          _vm._v(_vm._s(scope.row._contextSum))
                        ])
                      ]),
                      _c("div", [
                        _vm._v("current: "),
                        _c("span", { staticClass: "text-bold" }, [
                          _vm._v(_vm._s(scope.row._currentSum))
                        ])
                      ]),
                      _c("div", [
                        _vm._v("candidate: "),
                        _c("span", { staticClass: "text-bold" }, [
                          _vm._v(_vm._s(scope.row._candidateSum))
                        ])
                      ])
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "Warnings" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.warnings && scope.row.warnings.length
                      ? _c(
                          "div",
                          _vm._l(scope.row.warnings, function(warn, idx) {
                            return _c(
                              "div",
                              { key: idx, staticClass: "warning-item" },
                              [_vm._v(" " + _vm._s(warn) + " ")]
                            )
                          }),
                          0
                        )
                      : _c("span", { staticClass: "text-muted" }, [_vm._v("-")])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length || _vm.searchData.page > 1
        ? _c(
            "div",
            { staticClass: "custom-pagination" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", disabled: _vm.searchData.page === 1 },
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.searchData.page - 1)
                    }
                  }
                },
                [_vm._v(" 上一页 ")]
              ),
              _c("span", { staticClass: "page-num" }, [
                _vm._v("第 " + _vm._s(_vm.searchData.page) + " 页")
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "small", disabled: !_vm.hasMore },
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.searchData.page + 1)
                    }
                  }
                },
                [_vm._v(" 下一页 ")]
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px", "margin-left": "15px" },
                  attrs: { size: "small" },
                  on: { change: _vm.sizeChange },
                  model: {
                    value: _vm.searchData.limit,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "limit", $$v)
                    },
                    expression: "searchData.limit"
                  }
                },
                [
                  _c("el-option", { attrs: { value: 10, label: "10条/页" } }),
                  _c("el-option", { attrs: { value: 20, label: "20条/页" } }),
                  _c("el-option", { attrs: { value: 50, label: "50条/页" } }),
                  _c("el-option", { attrs: { value: 80, label: "80条/页" } })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }